import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as endpointsConnectorsVariablesAdmin from '../../actions/endpointsConnectorsVariablesAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/endpointsConnectorsVariablesAdmin/formPopup'
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import EntityUseQuery from '../entityUseQuery';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  deleteConfirmPopup: "deleteConfirmPopup",
  activeConfirmPopup: "activeConfirmPopup",  
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class EndpointsConnectorsVariablesAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.endpointsConnectorsVariablesList,
      entityApiKey: "endpoint_connector_variable",
      initialNewEntity: { name: "", value: ""},
      formHasChanges: false,      
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "endpointsConnectorsVariablesAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "endpointsConnectorsVariablesAdmin.entityNamePlural"})),
      intl.formatMessage({id: "endpointsConnectorsVariablesAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""),
      (this.props.save.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.save.errors.message : ""));

  }
  
  handleShowFormPopup = async (event) => {
    EntityTableTooling.handleShowFormPopup(this, event);
    if(!InterfaceTooling.popupHasToRender(EntityTableTooling.getFormPopupState(this))) { 
      if(event.currentTarget.dataset.entitydata) {
        var entityObject = JSON.parse(event.currentTarget.dataset.entitydata)
      }
    }
  };
  
  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.paramseditor || event.currentTarget.dataset.headerseditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;

      let objectDefinition = [];
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }

      if(isDelete) {
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } 
      else if(isEdit) {
        objectDefinition[index] = objectValue;
      } 
      else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(path, objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  // CURRENTLY NOT USED
  // 
  // handleShowFormPopupToClone = (event) => {
  //   InterfaceTooling.handleShowPopup(
  //     event, popupIds.formPopup, this.state, 
  //     this.setState.bind(this), (this.props.save.loading), () => {
  //       let entityObject = {};
  //       let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata);
  //       entityObject[this.state.entityApiKey] = parsedObject
  //       entityObject["clone"] = true;
  //       delete entityObject[this.state.entityApiKey]["id"];
  //       this.props.actions.resetSaveEntity(entityObject);              
  //       this.setState({ formHasChanges: false });
  //     }
  //   );
  // }

  render() {
    var loadingView = this.props.list.firstLoading;
    var errorLoadingView = this.props.list.status !== null && this.props.list.status !== 200;
    return (      
      <section className="dashboard_content_inner_view entity_admin_container endpoints_connectors_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
               <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={EntityTableTooling.handleOnChangeForm.bind(null, this)}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"endpointsConnectorsVariablesAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"endpointsConnectorsVariablesAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"endpointsConnectorsVariablesAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"endpointsConnectorsVariablesAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.endpointsConnectorsVariablesAdmin.list,
  save: state.reducer.endpointsConnectorsVariablesAdmin.save,
  delete: state.reducer.endpointsConnectorsVariablesAdmin.delete,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(endpointsConnectorsVariablesAdmin, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

EndpointsConnectorsVariablesAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EndpointsConnectorsVariablesAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/endpointsConnectorsVariablesAdmin/index.jsx